import CFDIComplements from '../Catalogs/complements.json'
import TipoComprobanteWebPortal from '../Catalogs/tipoComprobanteWebPortal.json'
import CFDIType from '../Catalogs/tipoComprobante.json'

export const getFilterByColumnValue = row => {
    const {rfcEmisor, rfcReceptor, cfdiComplement, cfdiType} = row;
    let filters = "";

    if (rfcReceptor) {
        filters += `Cliente: ${rfcReceptor.split(',').join(', ')} `;
    }

    if (rfcEmisor) {
        filters += `Proveedor: ${rfcEmisor} `;
    }

    if (cfdiType) {
        const ctype = CFDIType.find(t => t.key === cfdiType.toUpperCase());
        if (ctype) {
            filters += `Tipo: ${ctype.label} `;
        }

    }

    if (cfdiComplement) {
        // Search in WebService catalog first
        let cComplement = CFDIComplements.find(t => t.key === cfdiComplement);
        // If not found, search in WebPortal catalog
        if (!cComplement) {
            cComplement = TipoComprobanteWebPortal.find(t => t.key === cfdiComplement);
        }
        if(cComplement){
            filters += `Complemento: ${cComplement.label} `;
        }

    }
    return filters ? filters : "Ningúno";
}